<template>
  <div class="flex lg:justify-center font-poppins break-words">
    <table v-if="tableData && tableData.length > 0" class="w-full border-separate border-spacing-y-1.5 px-1.5">
      <thead>
        <tr class="rounded-lg border border-white shadow-[0_0_10px_0_#00000026]">
          <th v-for="(header, index) in tableHeaders" :key="header.title" @click="sortClicked(header)"
            class="px-2 py-[12px] text-[13px] font-semibold cursor-pointer" :class="{
              'rounded-l-lg': index === 0,
              'rounded-r-lg text-center': index === tableHeaders.length - 1,
              '!bg-customBlue-100 text-white': true,
            }">
            <span class="flex items-center" :class="{
              'justify-center': index === tableHeaders.length - 1,
            }">
              <span v-if="header.sort_applicable == '1'" class="max-h-5">
                <button v-if="header.sort_direction == ''" class="p-0 border-0 focus:outline-none">
                  <!-- <img src="../../assets/images/default-sort.svg" alt="Sorting Arrow" class="w-4 h-4 object-contain"> -->
                </button>
                <button v-else-if="header.sort_direction == 'ASC'" class="p-0 border-0 focus:outline-none">
                  <img src="../../assets/images/asc.svg" alt="Sorting Ascending Arrow" class="w-4 h-4 object-contain">
                </button>
                <button v-else-if="header.sort_direction == 'DESC'" class="p-0 border-0 focus:outline-none">
                  <img src="../../assets/images/desc.svg" alt="Sorting Descending Arrow" class="w-4 h-4 object-contain">
                </button>
                <button v-else class="p-0 border-0 focus:outline-none">
                  <!-- <img src="../../assets/images/default-sort.svg" alt="Sorting Arrow" class="w-4 h-4 object-contain"> -->
                </button>
              </span>
              {{ header.title }}
            </span>
          </th>
        </tr>
      </thead>
      <tbody class="bg-white text-slate-800 table-row-group space-y-2 w-full">
        <tr v-for="(item, rowIndex) in tableData" :key="rowIndex"
          class="group mt-1 transition-all duration-300 py-2 rounded-lg  shadow-[0_0_10px_0_#0000001f] "
          @click="() => $emit('itemClick', item)">
          <td v-for="(header, colIndex) in tableHeaders" :key="header.data_value"
            class="px-[8px] py-[9px] bg-white text-[13px] largeDesktop:text-[14px] font-normal border-y border-white border-solid group-hover:!border-customBlue-100"
            :class="{
              'rounded-l-lg': colIndex === 0,
              'rounded-r-lg': colIndex === tableHeaders.length - 1,
              'mobile:!min-w-[150px] mobile:!max-w-[110px] border-y border-l border-white border-solid group-hover:!border-customBlue-100': header.data_value === 'job_number',
              'mobile:!min-w-[60px]  mobile:!max-w-[120px]': header.data_value === 'assignee_name',
              'mobile:!min-w-[60px]  mobile:!max-w-[120px]': header.data_value === 'service_address',
              'mobile:!min-w-[60px]  mobile:!max-w-[120px]': header.data_value === 'trade_name',
              'mobile:!min-w-[60px]  mobile:!max-w-[120px]': header.data_value === 'service_name',
              'mobile:!min-w-[60px]  mobile:!max-w-[120px]': header.data_value === 'appointment_date_time',
              'mobile:!min-w-[60px]  mobile:!max-w-[120px]': header.data_value === 'progress_status_text',
              'mobile:!min-w-[80px] mobile:!max-w-[80px] border-y border-r border-white border-solid group-hover:!border-customBlue-100': header.data_value === 'action',
            }">

            <template v-if="header.data_value === 'job_number'">
              <div class="flex items-center gap-[5px]">
                <span
                  class="mobile:min-w-[120px] largeDesktop:min-w-[130px] mobile:text-[13px] largeDesktop:text-[14px]">
                  <router-link :to="{ name: 'workOrdersDetail', params: { id: item.appointment_id } }"
                    class="cursor-pointer text-[#2459A8]" @click.stop>
                    {{ item[header.data_value] }}
                  </router-link>
                </span>
                <div class="relative group/tooltip"> <img src="../../assets/images/map-icon-yellow.svg" alt="Info Icon"
                    class="min-w-[22px] min-h-[22px] max-w-[22px] max-h-[22px] cursor-pointer" />
                  <div
                    class="absolute -left-[10px] top-full mt-2 w-max max-w-[300px] bg-[#2459A8] text-white text-[14px] font-roboto font-normal px-3 py-2 rounded-[10px] border-[1px] border-[#fff] shadow-[0_0_10px_0_#00000026] opacity-0 group-hover/tooltip:!opacity-100 transition-opacity duration-200 pointer-events-none z-[999]">
                    <!-- Triangle -->
                    <span
                      class="absolute -top-[6px] left-[14px] w-0 h-0 shadow-[0_0_10px_0_#00000026] border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-b-[6px] border-b-[#2459A8]">
                    </span>
                    {{ item.service_address }}
                  </div>
                </div>
              </div>
            </template>

            <template
              v-else-if="header.data_value === 'requested_date_time'">
              <span>
                {{ item[header.data_value] != "-" ? $helper.formattedDate(item[header.data_value]) : '-' }}
              </span>
            </template>

            <template
              v-else-if="header.data_value === 'appointment_date_time'">
              <span>
                {{ item[header.data_value] != "-" ? $helper.formatDateTime(item[header.data_value]) : '-' }}
              </span>
            </template>

            <template v-else-if="header.data_value === 'assignee_name'">
              <span class="inline-block laptop:!max-w-[120px] largeDesktop:!max-w-[130px]">{{ item[header.data_value] }}</span>
            </template>

            <template v-else-if="header.data_value === 'partner_company_logo'">
              <img :src="item[header.data_value]" alt="Partner Company Logo" class="w-12 h-12 object-contain max-h-10">
            </template>

            <template v-else-if="header.data_value === 'progress_status_text'">
              <p v-if="item.progress_status_slug == 'open-lead'"
                class="inline-block text-center py-[1px] px-[10px] text-[13px] largeDesktop:text-[14px] rounded-[5px] mb-0 text-white bg-[#BA90C6]">
                {{ item[header.data_value] }}</p>
              <p v-else-if="item.progress_status_slug == 'contractor-confirmed'"
                class="inline-block text-center py-[1px] px-[10px] text-[13px] largeDesktop:text-[14px] rounded-[5px] mb-0 text-white bg-[#29C6CD]">
                {{ item[header.data_value] }}</p>
              <p v-else-if="item.progress_status_slug == 'en-route'"
                class="inline-block text-center py-[1px] px-[10px] text-[13px] largeDesktop:text-[14px] rounded-[5px] mb-0 text-white bg-[#125B9A]">
                {{ item[header.data_value] }}</p>
              <p v-else-if="item.progress_status_slug == 'arrived'"
                class="inline-block text-center py-[1px] px-[10px] text-[13px] largeDesktop:text-[14px] rounded-[5px] mb-0 text-white bg-[#00ADEF]">
                {{ item[header.data_value] }}</p>
              <p v-else-if="item.progress_status_slug == 'quote-submitted'"
                class="inline-block text-center py-[1px] px-[10px] text-[13px] largeDesktop:text-[14px] rounded-[5px] mb-0 text-white bg-[#8479E1]">
                {{ item[header.data_value] }}</p>
              <p v-else-if="item.progress_status_slug == 'checkout'"
                class="inline-block text-center py-[1px] px-[10px] text-[13px] largeDesktop:text-[14px] rounded-[5px] mb-0 text-white bg-[#54B435]">
                {{ item[header.data_value] }}</p>
              <p v-else-if="item.progress_status_slug == 'close'"
                class="inline-block text-center py-[1px] px-[10px] text-[13px] largeDesktop:text-[14px] rounded-[5px] mb-0 text-white bg-[#686D76]">
                {{ item[header.data_value] }}</p>
              <p v-else-if="item.progress_status_slug == 'quote-decline'"
                class="inline-block text-center py-[1px] px-[10px] text-[13px] largeDesktop:text-[14px] rounded-[5px] mb-0 text-white bg-[#C768FF]">
                {{ item[header.data_value] }}</p>
              <p v-else-if="item.progress_status_slug == 'cancellation-requested'"
                class="inline-block text-center py-[1px] px-[10px] text-[13px] largeDesktop:text-[14px] rounded-[5px] mb-0 text-white bg-[#E8B008]">
                {{ item[header.data_value] }}</p>
              <p v-else-if="item.progress_status_slug == 'cancelled'"
                class="inline-block text-center py-[1px] px-[10px] text-[13px] largeDesktop:text-[14px] rounded-[5px] mb-0 text-white bg-[#FE5000]">
                {{ item[header.data_value] }}</p>
              <p v-else-if="item.progress_status_slug == 'authorized'"
                class="inline-block text-center py-[1px] px-[10px] text-[13px] largeDesktop:text-[14px] rounded-[5px] mb-0 text-white bg-[#9C9BBF]">
                {{ item[header.data_value] }}</p>
              <p v-else>{{ item[header.data_value] }}</p>
            </template>

            <template v-else-if="header.data_value === 'action'">
              <actionDropdown :item="item" @select="(data) => select(item, data)"></actionDropdown>
            </template>

            <template v-else>
              {{ item[header.data_value] }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-else
      class="flex justify-center items-center text-[20px] laptop:text-[30px] min-h-[60vh] 2xl:min-h-[80vh] m-0 text-[#333333]">
      No Record Found</p>
  </div>
</template>

<script>
import actionDropdown from './workOrderActionDropdown.vue';
export default {
  props: ["tableHeaders", "tableData", "sortClicked", "isLoading"],
  components: {
    actionDropdown
  },
  methods: {
    getStatusClass(status) {
      const statusClasses = {
        'approved': '#65B741',
        'pending': '#F39C12',
        'rejected': '#D7385E',
      };
      return statusClasses[status] || 'bg-gray-500';
    },
    select(item, value) {
      this.$emit('update', item, value); // emit change if needed
    },
  }
};
</script>
